const IssueMethod = Object.freeze({
    IN_PERSON: 0,
    POST: 1,
    COLLECTION: 2
})

export default IssueMethod